export enum FocusedElement {
  CardNumber,
  CardName,
  ExpirationDate,
  CVV,
}
